export default __webpack_public_path__ + "static/media/Rampver_Online_Logo.a187eafb.png";